var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInput({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18C9.8054 18 7.27505 16.8073 5.55755 14.7276L6.71405 13.7724C8.14558 15.5058 10.2546 16.5 12.5 16.5C16.6354 16.5 20 13.1355 20 8.99995C20 4.86445 16.6354 1.49995 12.5 1.49995C10.2546 1.49995 8.14558 2.49415 6.71405 4.22755L5.55755 3.27228C7.27505 1.19268 9.8054 -0.00012207 12.5 -0.00012207C17.4627 -0.00012207 21.5 4.03728 21.5 8.99988C21.5 13.9625 17.4627 18 12.5 18Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 9.00003L11 3.75003L9.93943 4.8106L13.3789 8.25003H0.5V9.75003H13.3789L9.93943 13.1895L11 14.25L16.25 9.00003Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInput);
export default __webpack_public_path__ + "static/media/ic-input.199b210c94e0e3982b388845852b1197.svg";
export { ForwardRef as ReactComponent };